export const ROLES = {
  ADMIN: 'ADMIN',
  CREATOR: 'CREATOR',
  USER: 'USER',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export interface AuthUser {
  id: string;
  email: string;
  name: string;
  roles: Role[];
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

/**
 * Shape returned by the backend for login/refresh alike. It carries no
 * nested `user`/roles - the FE derives `AuthUser` by decoding the access
 * token's JWT claims (see `userFromAccessToken` in `store/auth.store.ts`).
 */
export interface AuthResponse extends AuthTokens {
  userId: string;
  email: string;
  tokenType: string;
}
